import "trix"
import "@rails/actiontext"
import "@hotwired/turbo-rails"
import "../controllers/index"
import "../navbar"
import  { Dropdown, Collapse } from "bootstrap"

Array.from(document.querySelectorAll('.dropdown-toggle')).map(n => new Dropdown(n))
Array.from(document.querySelectorAll('.collapse')).map(n => new Collapse(n, { toggle: false }))
